import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  button: {
    borderRadius: 4,
    height: 50,
    width: '100%',
    fontSize: 20,
    marginBottom: theme.spacing(2),
    '& svg': { height: 20, width: 20 },
    [theme.breakpoints.up('mobile')]: {
      width: 350,
      marginRight: theme.spacing(2),
    },
  },
  star: {
    color: theme.palette.colors.yellow,
    fontSize: 36,
  },
  starContainer: {
    marginTop: 30,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('mobile')]: {
      marginTop: 50,
    },
  },
  starDesc: {
    display: 'flex',
    justifyContent: 'center',
    margin: [10, 0, 30],
  },
  quoteContainer: {
    borderRadius: 4,
    padding: 20,
    backgroundColor: theme.palette.colors.lightTealBackground,
    maxWidth: 600,
    [theme.breakpoints.up('mobile')]: {
      margin: 'auto',
    },
  },
  openQuote: {
    transform: 'scaleX(-1)',
    color: theme.palette.colors.teal,
    fontSize: 40,
  },
  quote: {
    fontStyle: 'italic',
  },
  quoteBy: {
    color: theme.palette.colors.teal,
  },
  quoteByDesc: {
    marginLeft: 30,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurveyFlowSelect/useStyles.js